// src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { capturePageview, trackEvent } from '../lib/analytics';
import zapataLogo from '../assets/zapata-logo.png'; // Usando tu logo existente
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currentGreetingIndex, setCurrentGreetingIndex] = useState(0);

  const { login } = useAuth();

  // Login vive fuera de ProtectedRoute/AppContent — sin esto, un login
  // colgado o fallido era invisible para PostHog (ni pageview ni error),
  // que es justo lo que pasó el 2026-11-03.
  useEffect(() => {
    capturePageview('login');
  }, []);

  // Array de saludos en diferentes idiomas
  const greetings = [
    { text: "Hola", language: "Español" },
    { text: "Hello", language: "English" },
    { text: "Bonjour", language: "Français" },
    { text: "Ciao", language: "Italiano" },
    { text: "Hallo", language: "Deutsch" },
    { text: "Olá", language: "Português" },
    { text: "Привет", language: "Русский" },
    { text: "你好", language: "中文" },
    { text: "こんにちは", language: "日本語" },
    { text: "مرحبا", language: "العربية" }
  ];

  // Efecto para cambiar el saludo cada 2 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGreetingIndex((prevIndex) => 
        (prevIndex + 1) % greetings.length
      );
    }, 2000); // Cambia cada 2 segundos

    return () => clearInterval(interval);
  }, [greetings.length]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Limpiar error al escribir
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const { email, password } = formData;

    if (!email || !password) {
      setError('Por favor, completa todos los campos');
      setIsLoading(false);
      return;
    }

    const result = await login(email, password);

    if (!result.success) {
      setError(result.error);
      trackEvent('error_app', { source: 'login_failed', message: String(result.error || '').slice(0, 200) });
    }

    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <img 
              src={zapataLogo} 
              alt="Climatización Zapata Logo" 
              className="login-logo"
            />
          </div>
          <div className="greeting-container">
            <h1 className="animated-greeting">
              {greetings[currentGreetingIndex].text}
            </h1>
          </div>
          <p>Inicia sesión para acceder a la aplicación</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="usuario@empresa.com"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Ingresa tu contraseña"
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;